import { Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedin, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';


const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="d-flex flex-wrap justify-content-center align-items-center position-absolute bottom-0 lh-1">
            <div className="col-md-6 ms-5 d-none d-lg-flex">
                Copyright &copy;<span className="mx-1">{currentYear}</span>BCD&nbsp;|&nbsp;
                <a href="https://www.bcdvideo.com/privacy-policy/" className="text-nowrap" target="_blank" rel="noopener noreferrer">Privacy Policy</a>&nbsp;|&nbsp;
                <a href="https://www.bcdvideo.com/terms-of-use/" className="text-nowrap" target="_blank" rel="noopener noreferrer">Terms of Use</a>&nbsp;|&nbsp;
                <a href="https://www.bcdvideo.com/contact-us/" className="text-nowrap" target="_blank" rel="noopener noreferrer">Contact Us</a>
            </div>
            <div className="col-md-4 d-flex justify-content-end me-md-5">
                <Nav>
                    <NavItem className="ms-4">
                        <NavLink href="https://www.facebook.com/BCDVideo/" target="_blank" rel="noopener noreferrer" aria-label="BCD on Facebook">
                            <FontAwesomeIcon icon={faFacebookF} size="lg" />
                        </NavLink>
                    </NavItem>
                    <NavItem className="ms-2">
                        <NavLink href="https://twitter.com/bcdvideo" target="_blank" rel="noopener noreferrer" aria-label="BCD on X (Twitter)">
                            <FontAwesomeIcon icon={faXTwitter} size="lg" />
                        </NavLink>
                    </NavItem>
                    <NavItem className="ms-2">
                        <NavLink href="https://www.linkedin.com/company/bcdvideo" target="_blank" rel="noopener noreferrer" aria-label="BCD on LinkedIn">
                            <FontAwesomeIcon icon={faLinkedin} size="lg" />
                        </NavLink>
                    </NavItem>
                    <NavItem className="ms-2">
                        <NavLink href="https://www.youtube.com/channel/UCx68_UUkisBTlgFvBD0XzIQ" target="_blank" rel="noopener noreferrer" aria-label="BCD on YouTube">
                            <FontAwesomeIcon icon={faYoutube} size="lg" />
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
        </footer>
    );
}

export default Footer;